// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoMember {\n  width: 72.7px;\n  height: 52px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.logoMember:hover {\n  -webkit-filter: opacity(75%);\n          filter: opacity(75%);\n}", ""]);
// Exports
module.exports = exports;
